var render = function render(_c,_vm){return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }